import React, { useState, useEffect } from "react";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { Tooltip } from "@material-ui/core";
import { Link, useLocation } from 'react-router-dom';
import { DatePickerInput } from 'rc-datepicker';
import 'moment/locale/it.js';
import 'rc-datepicker/lib/style.css';
import Moment from "moment";
import { Grid, Paper } from "@material-ui/core";
import BiztranControls from "../../biztran_controls/BiztranControls";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import UseFetchData from "../../../hooks/UseFetchData";
import CreateDeliveryChallan from "./CreateDeliveryChallan"

const todate = new Date()
const Dfromdate = todate.getFullYear() + '/01/01';
const fromdate = new Date(todate.getFullYear(), todate.getMonth(), todate.getDate() - 60);

const DeliveryChallan = () => {
    const [DeliveryChallanNo, setDeliveryChallanNo] = useState('');
    const [AccountID, setAccountID] = useState('');
    const [AccountName, setAccountName] = useState('');
    const [AccName, setAccName] = useState('');
    const [responseAccount, fetchAccountData] = UseFetchData();
    const [AccountOptions, setAccountOptions] = useState([]);
    const [Status, setStatus] = useState('');
    const [Description, setDescription] = useState('');
    const [City, setCity] = useState('');
    const [FromDate, setFromDate] = useState(fromdate);
    const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
    const [ToDate, setToDate] = useState(todate.toISOString());
    const [defaultToDate, setdefaultToDate] = useState(todate);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [isOpen, setOpen] = useState(false);
    const [DeliveryChallanID, setDeliveryChallanID] = useState('');
    const [Count, setCount] = useState();
    const [ProductID, setProductID] = useState('');
    const [Mode, setMode] = useState('');
    const [ProductIDcmb, setProductIDcmb] = useState([]);
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [response, fetchData] = UseFetchData();
    const [SearchMode, setSearchMode] = useState("SEARCH");
    const location = useLocation();


    const AccountData = () => {
        var bodyFormData = new FormData();
        fetchAccountData("DeliveryChallan/ComboDataDC", bodyFormData);
    }

    const onFromClear = () => {
        setFromDate();
        setdefaultfromDate();
    }

    const onToClear = () => {
        setToDate();
        setdefaultToDate();
    }
    const StatusOption = [
        { id: "Stage 1", title: "Stage 1" },
        { id: "Stage 2", title: "Stage 2" },
        { id: "Stage 3", title: "Stage 3" },
        { id: "Stage 4", title: "Stage 4" },
    ];


    const onACCChange = (event, newValue) => {
        // debugger;
        setAccountName(newValue);
        setAccountID(newValue.id);
    }

    const PopulateData = (value) => {
        debugger;
        var bodyFormData = new FormData();
        var AccoName = "",
            AcName = null;
        if (AccountName !== undefined) {
            AccoName = AccountName.List;
        }
        if (AccName !== "") {
            AcName = AccName;
        }
        setSearchMode(SearchMode);
        // if (AccountName == "" && location.state == undefined) {
        // }
        // else if (value == "SEARCH") {
        bodyFormData.append("AccountName", AccoName);
        // }
        // else if (location.state.Account != "" && location.state != undefined) {
        //     var AccountN = location.state.Account;
        //     bodyFormData.append("AccountName", AccountN); 
        // }
        // if (City == "" && location.state == undefined) {
        // }
        // else if (value == "SEARCH") {
        //     bodyFormData.append("City", City);
        // }
        // else if (location.state.BCity != "" && location.state != undefined) {
        //     var Citi = location.state.BCity;
        //     bodyFormData.append("City", Citi);
        // }
        bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
        bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
        fetchData("DeliveryChallan/List", bodyFormData);
    }

    const handleOpenModal = () => {
        setOpen(true);
        setMode("Insert");
        setDeliveryChallanID('');
    }



    useEffect(() => {
        const gridCols = [
            {
                field: "id",
                headerName: " .",
                renderCell: (params) => (<strong> <Link to={{ pathname: "/deliveryChallan/DeliveryChallanView", state: { DeliveryChallanID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 70
            },
            {
                field: "DeliveryChallanNo",
                headerName: "DC NO",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150
            },
            {
                field: "DeliveryChallanDate",
                headerName: "DC Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150
            },
            {
                field: "AccountName",
                headerName: "Account",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 210,
            },
            {
                field: "ProductName",
                headerName: "Product Details",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "DDescription",
                headerName: "Description",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
                renderCell: (params) => (
                    <Tooltip title={params.row.DDescription} >
                        <span className="table-cell-trucate">{params.row.DDescription}</span>
                    </Tooltip>
                )
            },
            // {
            //     field: "HandledBy",
            //     headerName: "Handled By",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 180,
            // },
            {
                field: "CreatedBy",
                headerName: "Created By",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "ModifiedBy",
                headerName: "Modified By",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },];
        setColumns(gridCols);
        setRows(response);
        setCount(response.length);

    }, [response, SearchMode]
    );
    useEffect(() => {
        // debugger;
        if (responseAccount['cmbAccount'] !== undefined && responseAccount['cmbAccount'].length > 0) {
            setAccountOptions(responseAccount['cmbAccount']);
        }
    }, [responseAccount['cmbAccount']]);

    useEffect(() => {
        PopulateData('');
        AccountData();
    }, [])

    return <div>
        <Grid container direction="row" style={{ marginTop: 20 }} spacing={0.5}>
            <Grid item xs={12} sm={6} md={3} lg={3} xl={2}>
                <BiztranControls.Autocomplete
                    label="Account Name"
                    options={AccountOptions}
                    style={{ marginLeft: 7, marginTop: -10, width: "250px" }}
                    onChange={onACCChange}
                    value={AccName}>
                </BiztranControls.Autocomplete>
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={2} xl={2} style={{ marginTop: -12, }}>
                <div style={{ width: "200px", marginLeft: 7 }}>
                    <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
                    <DatePickerInput
                        onChange={(jsDate, dateString) => setFromDate(dateString)}
                        locale="en"
                        displayFormat="DD/MMM/YYYY"
                        className='my-react-component'
                        onClear={() => { onFromClear(); }}
                        showOnInputClick
                        maxDate={new Date()}
                        returnFormat="YYYY/MM/DD"
                        defaultValue={defaultfromDate}
                    />
                </div>
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={2} xl={2} style={{ marginTop: -12, marginLeft: 10 }}>
                <div style={{ width: "200px" }}>
                    <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
                    <DatePickerInput
                        onChange={(jsDate, dateString) => setToDate(dateString)}
                        locale="en"
                        displayFormat="DD/MMM/YYYY"
                        className='my-react-component'
                        onClear={() => { onToClear(); }}
                        showOnInputClick
                        maxDate={new Date()}
                        returnFormat="YYYY/MM/DD"
                        defaultValue={defaultToDate}
                    />
                </div>
            </Grid>
            <Grid container xs={12} sm={12} md={5} lg={4} xl={2} direction="row" >
                <Grid item style={{ marginTop: 10 }} >
                    <label style={{ fontWeight: 'bold', width: 30, marginLeft: 7 }}>{Count}</label>
                </Grid>
                <Grid item >
                    <BiztranControls.Button
                        text="SEARCH"
                        startIcon={<SearchIcon />}
                        onClick={() => {
                            PopulateData('SEARCH');
                        }}
                    />
                </Grid>
                <Grid item >
                    <BiztranControls.Button
                        text="ADD NEW"
                        startIcon={<AddCircleOutlineIcon />}
                        onClick={() => {
                            handleOpenModal();
                        }}
                    />
                </Grid>
            </Grid>
        </Grid>
        <BiztranControls.DataGrid
            rows={rows}
            columns={columns}
            headerHeight={34}
            rowHeight={25}
            checkboxSelection={false}
            // autoHeight={true}
            Height="520px"
            width="100%"
        />
        <ModalFrame
            title="DeliveryChallan Details"
            maxWidth="md"
            isOpen={isOpen}
            setOpen={setOpen}
        >
            <CreateDeliveryChallan
                Mode={Mode}
                setOpen={setOpen}
                PopulateData={PopulateData}
            />
        </ModalFrame>
    </div >;
};
export default DeliveryChallan;